/**
 * imposes maximum allowed width for the entire application, and centers
 * content automatically if the browser window is too wide.
 */
const centerCls = "_yr2cv32ymd";

export { centerCls };
import "./Center.linaria.module.css";
//# sourceMappingURL=Center.js.map
